import axios from './axios';
import { ApiResponseCode as Code } from './const';

const ProjectCode = process.env.VUE_APP_PROJECTCODE;

export default {
  /**
   * 更新 API Token
   * @param token 新的 token
   */
  updateToken(token) {
    axios.updateToken(token);
  },

  /**
   * 食物品項分類資訊
   * @param params 參數
   * @param params.memberCode 會員號碼, 10碼
   */
  getClassification() {
    const params = { ProjectCode };
    return new Promise((resolve, reject) => {
      axios
        .get('MapClassificationInfo', params)
        .then((res) => {
          if (res.code === Code.Success) {
            resolve(res.data);
          } else {
            throw res;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * 取得地圖產品數量資訊
   * @param params 參數
   * @param params.OldPKeys 特定店代號
   * @param params.PostInfo 郵遞區號或是"台北市" (縣市名表示該縣市下所有全家店)
   * @param params.Latitude 店家地理緯度數字
   * @param params.Longitude 店家地理經度數字
   */
  getFoods(OldPKeys = [], PostInfo = '', Latitude = 0, Longitude = 0) {
    return new Promise((resolve, reject) => {
      const params = {
        ProjectCode,
        OldPKeys,
        PostInfo,
        Latitude,
        Longitude,
      };

      axios
        .post('MapProductInfo', params)
        .then((res) => {
          if (
            (res.code === Code.Success && res.data) ||
            (res.code === Code.NotCherishFoodTime && res.data)
          ) {
            resolve(res.data);
          } else {
            const errorMessage = {
              code: Code.Fail,
              message: '',
            };
            reject(errorMessage);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * 取得地圖列表資訊
   */
  getMapList() {
    return new Promise((resolve, reject) => {
      axios
        .get('MapList')
        .then((res) => {
          if (res.code === Code.Success) {
            resolve(res.data);
          } else {
            throw res;
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
